import { useCallback } from 'react'
import { useDropzone, FileRejection } from 'react-dropzone'
import { History } from 'history'
import { AddPhotosStore, FileData } from '../../stores/AddPhotosStore'
import AlbumModel from '../../models/album'
import { ACCEPTED_FILE_TYPES } from '../../constants/acceptedFileTypes'

interface UseDropZoneWrapperProps {
  addPhotosStore: AddPhotosStore
  workspaceId: string
  workspaceSlug: string
  history: History
  albumId?: string
  album?: AlbumModel
}

export const useDropZoneWrapper = ({
  addPhotosStore,
  workspaceId,
  workspaceSlug,
  history,
  albumId,
  album,
}: UseDropZoneWrapperProps) => {
  const onDrop = useCallback(
    (acceptedFiles: File[], _rejections: FileRejection[]) => {
      if (acceptedFiles.length === 0) return

      const filesData: FileData[] = acceptedFiles.map((file) => {
        const key = `${file.name}${file.lastModified}${file.size}`
        const fileData = new FileData(key, file)
        fileData.setWorkspaceId(workspaceId)
        if (album) {
          fileData.setAlbum(album)
        }
        return fileData
      })

      addPhotosStore.queueFiles(filesData)
      history.push(`/${workspaceSlug}/upload`)
    },
    [addPhotosStore, workspaceId, workspaceSlug, history, albumId, album]
  )

  const dropzone = useDropzone({
    onDrop,
    accept: ACCEPTED_FILE_TYPES,
    noClick: true,
    noKeyboard: true,
  })

  return dropzone
}
